import { Injectable } from '@angular/core';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { ItineraryService } from 'app/shared/itinerary.service';
import { IProductBase, IProductCreationParams, IProductDeleteParams, IProductReservationBase, IProductReservationParams, IProductService } from 'model/product.interface';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseProductService implements IProductService {

  constructor(protected itineraryService: ItineraryService, protected userService: UserService) {}

  abstract createProduct(params: IProductCreationParams): IProductBase;

  abstract createReserve(params: IProductReservationParams): IProductReservationBase;

  abstract deleteProduct(params: IProductDeleteParams): IProductBase;

  abstract validateProduct(item: any): boolean;

}
